import React from 'react';

// Floating chip above (or below) the YOU pin so the user's finger doesn't hide
// the live X/Y values they just placed. Position is given as 0..100 normalised
// to the chart; the chip flips below the pin when near the top of the plot.
const PinPreviewChip = ({
  x = 50,
  y = 50,
  xLabel = 'X',
  yLabel = 'Y',
  xValue,
  yValue,
}) => {
  // Flip below the pin when it's near the top of the chart so the chip stays inside.
  const placeBelow = y > 78;
  const verticalShift = placeBelow ? 'calc(-50% + 36px)' : 'calc(-50% - 36px)';

  return (
    <div
      style={{
        position: 'absolute',
        left: `${x}%`, top: `${100 - y}%`,
        transform: `translate(-50%, ${verticalShift})`,
        zIndex: 8,
        pointerEvents: 'none',
        animation: 'penChipPop 260ms var(--ease-pop) both',
      }}
    >
      <div style={{
        display: 'flex', gap: 4,
        background: 'var(--c-ink)',
        padding: '3px 5px',
        borderRadius: 6,
        border: '1.5px solid var(--c-ink)',
        boxShadow: 'var(--shadow-hard-sm)',
        whiteSpace: 'nowrap',
      }}>
        <span style={{
          fontFamily: 'var(--font-mono)', fontWeight: 700, fontSize: 9,
          color: 'var(--c-blue)', letterSpacing: 0.3,
        }}>{xLabel.toString().toUpperCase()} {xValue ?? '—'}</span>
        <span style={{ color: 'var(--c-cream)', opacity: 0.4, fontSize: 9 }}>·</span>
        <span style={{
          fontFamily: 'var(--font-mono)', fontWeight: 700, fontSize: 9,
          color: 'var(--c-yellow)', letterSpacing: 0.3,
        }}>{yLabel.toString().toUpperCase()} {yValue ?? '—'}</span>
      </div>
      {/* small pointer connecting chip to pin */}
      <div style={{
        position: 'absolute', left: '50%',
        top: placeBelow ? -4 : 'auto',
        bottom: placeBelow ? 'auto' : -4,
        transform: 'translateX(-50%) rotate(45deg)',
        width: 6, height: 6,
        background: 'var(--c-ink)',
        borderRight: '1.5px solid var(--c-ink)',
        borderBottom: '1.5px solid var(--c-ink)',
      }} />
    </div>
  );
};

export default PinPreviewChip;
